<ion-card (click)="viewStory()" mode="ios" class="deal-card" [style.height]="cardHeight">
    <ion-grid fixed id="main-grid">
      <ion-row  id="main-row">
        <ion-col id="main-col">
          <div id="img-container" class="fade-in">
            <img  
            [style.height]="cardHeight"
            id="background-image"
            [defaultImage]="assetLinksService.cardLoading" 
            [lazyLoad]="story.picture" 
            [errorImage]="assetLinksService.noImage"
            onerror="this.src='assets/errorimg_ink.png'">
          </div>
        </ion-col>
      </ion-row>
      <div id="text-container">
        <ion-row class="fade-in" *ngIf="!showDescription"  >
          <ion-col>
          <p id="reward"> {{story.name}}</p>
          </ion-col>
        </ion-row>
        <!-- <ion-row class="fade-in" *ngIf="showDescription"  (click)="toggleShowDescription()">
          <ion-col >
            <p id="description"> {{story.description}}</p>
          </ion-col>
        </ion-row> -->


        <!-- <ion-fab *ngIf="story.link" (click)="toggleShowDescription()" edge="true" vertical="top" horizontal="end" shape="round" slot="fixed" >
          <ion-fab-button size="small">
            <ion-icon *ngIf="!showDescription" name="caret-up"></ion-icon>
            <ion-icon *ngIf="showDescription;" name="caret-down"></ion-icon> -->
            <!-- <ng-template #spinner>
              <ion-spinner name="circular"></ion-spinner>
            </ng-template> -->
          <!-- </ion-fab-button>
        </ion-fab> -->
      </div>
    </ion-grid>
</ion-card>

